module.exports = __webpack_public_path__ + "static/media/test9_2.2cd2bd69.png";